<template>
  <div class="basic-block block-about-counselor-base" :style="styles">
    <div class="content-wrap">
      <div class="block-about-counselor-base__inner">
        <div class="block-about-counselor-base__wrap">
          <h3 class="block-about-counselor-base__headline">釋斗弥（しゃく とうわ）</h3>
          <p class="block-about-counselor-base__text">
            2021年11月～TBS「占いメガネ」<br>
            2022年1月～テレビ東京「どこまで言っていいですか？」<br>
            老舗クラブでのホスト経験を持つ異色の占い師。数奇な運命に引き寄せられ赴いた熊本で、占いカフェバーのオーナーになり、地元メディアの常連となる。ホスト時代に鍛えた人間観察力を土台にしたわかりやすい表現で、心のひだまで届く鑑定を行い、自分らしい生き方を探す老若男女に人気を博している。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockAboutCounselor2',
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-about-counselor-base {
  padding: 0;
  margin-bottom: 40px;
  background: #fff;
  &__deco {
    position: absolute;
    top: -27px;
    left: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 2;
  }
  &__inner {
    padding: 22px 20px 0 unquote('min(32.266%, 180px)');
    background: url('/static/img/recommend/lp/touwa/counselor6.jpg') no-repeat 0 100%/195px auto;
    min-height: 223px;
    display: flex;
  }
  &__wrap {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(5px);
    padding: 0 0 20px 6px;
  }
  &__headline {
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    text-align: justify;
    color: $l_col_keycolor;
    margin: 0 0 8px;
  }
  &__text {
    font-size: 12px;
    line-height: 18px;
    text-align: justify;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockAboutCounselor2.vue